
  import React from "react"
  import Component from "/home/knipp/workspace/gatsby/kinderbetreuungsatlas/src/layouts/index.js"
  import data from "/home/knipp/workspace/gatsby/kinderbetreuungsatlas/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js